import { DialogueUIConfig, DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";

export default class Scenario5Part4 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {		
		scenario5_1B_s12: 'CALM - Scenario 5 - 1B - Segment 12',
		scenario5_4A_s13: 'CALM - Scenario 5 - 4A - Segment 13',
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];	}

	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part4.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();
	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.segment1Step2Dialogue();
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C08-L2-050b',
			[{
				text: 'First, go get the blood from the lab. We can deal with the verification after.',
				feedback: 'For training purposes let’s go ahead and tell Miranda to find a second RN to verify and help monitor.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'Okay, go ahead and find a second RN to help you verify and monitor.',				
				scoreType: ScoreType.Best,
				isCorrect: true // Rank Best/S
			}, {
				text: 'I’ll verify for you and help monitor the patient.',
				feedback: 'For training purposes let’s go ahead and tell Miranda to find a second RN to verify and help monitor.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.segment2Step1MirandaDeparts();
				}, () => {
					context.segment2Step1MirandaDeparts();
					}
				)
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'First, go get the blood from the lab. We can deal with the verification after.',							
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'Okay, go ahead and find a second RN to help you verify and monitor.',				
							scoreType: ScoreType.Best,
							isCorrect: true // Rank Best/S
						}, {
							text: 'I’ll verify for you and help monitor the patient.',							
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}
					],
					aarScenarioID: 1,
					aarSectionID: 2,
					aarCollectionID: [config.selectedAnswer]
				}, () => { }, context.partIndx)
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment2Step1MirandaDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_1B_s12, () => {
			context.segment2Step2Marco();
		});
		context.scenario.updateObjective('');
	}

	private segment2Step2Marco() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_4A_s13, () => {
			this.onDone();
		});
		context.scenario.updateObjective('');
	}
}